import { render, staticRenderFns } from "./CardSource.vue?vue&type=template&id=2c0a1d69"
import script from "./CardSource.vue?vue&type=script&lang=js"
export * from "./CardSource.vue?vue&type=script&lang=js"
import style0 from "./CardSource.vue?vue&type=style&index=0&id=2c0a1d69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports